// import React, { useEffect, useState } from "react";
// import { Col, Table, Spinner, Badge, Row, Form, Card, Button } from "react-bootstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { authHeader } from "../../../services/auth-header";
// import { BASE_URL } from "../../../services/Api";
// import Swal from "sweetalert2";

// const SalesAMView = () => {
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [isLoading, setIsLoading] = useState(true);
//     const [salesData, setSalesData] = useState(null);
//     const [exportchargescurrency, setExportchargescurrency] = useState(0);
//     const [rows, setRows] = useState([]);

//     const fetchSalesData = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
//                 headers: authHeader()
//             });

//             const data = response.data;
//             setSalesData(data);
//             setExportchargescurrency(data.exportpreperationchargescurrency || 0);

//             if (data.salesItems && data.salesItems.length > 0) {
//                 setRows(data.salesItems.map(item => ({
//                     description: item.product?.description || '',
//                     productremarks: item.productremarks || "",
//                     quantity: item.quantity,
//                     unitratecurrency: item.unitratecurrency,
//                     totalcurrency: item.totalcurrency,
//                     exchangerate: item.exchangerate,
//                     unitRateInr: item.unitrateinr,
//                     totalInr: item.totalinr,
//                     hsnsacno: item.hsnsacno,
//                     partno: item.partno,
//                     serialnumber: item.serialnumber,
//                     modelnumber: item.modelnumber,
//                     tagnumber: item.tagnumber,
//                     moc: item.moc || "",
//                     itemcode: item.itemcode || "",
//                     uom: item.uom,
//                     currency: item.currency || "$ (USD)"
//                 })));
//             }
//         } catch (error) {
//             console.error("Error fetching sales data", error);
//             Swal.fire({
//                 icon: "error",
//                 title: "Error",
//                 text: "Failed to fetch sales data. Please try again.",
//             });
//             navigate("/salesIndexTable/1");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchSalesData();
//     }, [id]);

//     const formatDate = (dateString) => {
//         if (!dateString) return '-';
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-GB');
//     };

//     const formatNumber = (value) => {
//         if (value === null || value === undefined || value === '') return '0.00';
//         const num = parseFloat(value);
//         return isNaN(num) ? '0.00' : num.toFixed(2);
//     };

//     const formatNumberWithCommas = (value) => {
//         if (value === null || value === undefined || value === '') return '0.00';
//         const num = parseFloat(value);
//         return isNaN(num) ? '0.00' : num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     };

//     const getStatusBadge = (status) => {
//         switch (status) {
//             case 'Draft':
//                 return 'secondary';
//             case 'Submitted':
//                 return 'primary';
//             case 'Approved':
//                 return 'success';
//             case 'Rejected':
//                 return 'danger';
//             case 'Completed':
//                 return 'info';
//             case 'Open':
//                 return 'warning';
//             default:
//                 return 'light';
//         }
//     };

//     if (isLoading) {
//         return (
//             <div className="container text-center py-5">
//                 <Spinner animation="border" />
//                 <p>Loading sales details...</p>
//             </div>
//         );
//     }

//     if (!salesData) {
//         return (
//             <div className="container text-center py-5">
//                 <p>No sales data found</p>
//             </div>
//         );
//     }

//     return (
//         <div className="container">
//             <br />
//             <Card.Header className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0">International Pump Sales Details</h5>
//                 <Button
//                     variant="primary"
//                     onClick={() => navigate(`/salesInvoiceManufacturingInternational/print/${id}`)}
//                 >
//                     <i className="bi bi-printer me-2"></i>PRINT
//                 </Button>
//             </Card.Header>
//             <hr />
//             <Form>
//                 {/* Header Information */}
//                 <Row>
//                     <Col md={6}><p><strong>Invoice No:</strong> {salesData.invoiceno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Invoice Date:</strong> {formatDate(salesData.invoicedate)}</p></Col>
//                     <Col md={6}><p><strong>Tally Reference No:</strong> {salesData.tallyreferenceno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Dispatch Through:</strong> {salesData.dispatchthrough || '-'}</p></Col>
//                     <Col md={6}><p><strong>Status:</strong> <Badge bg={getStatusBadge(salesData.status)}>{salesData.status || '-'}</Badge></p></Col>
//                     <Col md={6}><p><strong>Currency:</strong> {salesData.salescurrency || '$ (USD)'}</p></Col>
//                     <Col md={6}><p><strong>Exchange Rate:</strong> {formatNumber(salesData.salesexchangerate)}</p></Col>
//                     <Col md={6}><p><strong>Branch:</strong> {salesData.branch?.branchname || '-'}</p></Col>
//                     <Col md={6}><p><strong>Warehouse:</strong> {salesData.warehouse?.warehousename || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>International Sales Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Kind Attention:</strong> {salesData.kindattn || '-'}</p></Col>
//                     <Col md={6}><p><strong>Country of Destination:</strong> {salesData.countryofdestination || '-'}</p></Col>
//                     <Col md={6}><p><strong>Country of Origin:</strong> {salesData.countryoforigin || '-'}</p></Col>
//                     <Col md={6}><p><strong>Air/Sea:</strong> {salesData.airsea || '-'}</p></Col>
//                     <Col md={6}><p><strong>Port of Loading:</strong> {salesData.portofloading || '-'}</p></Col>
//                     <Col md={6}><p><strong>Port of Discharge:</strong> {salesData.portofdischarge || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Shipping Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={4}><p><strong>No. of Boxes:</strong> {salesData.noofboxes || '-'}</p></Col>
//                     <Col md={4}><p><strong>Net Weight (kg):</strong> {salesData.netweightofboxes || '-'}</p></Col>
//                     <Col md={4}><p><strong>Gross Weight (kg):</strong> {salesData.grossweightofboxes || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Customs & Regulatory Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>LUT Bond No:</strong> {salesData.lutbondno || '-'}</p></Col>
//                     <Col md={6}><p><strong>LUT Bond Date:</strong> {formatDate(salesData.lutbonddate)}</p></Col>
//                     <Col md={6}><p><strong>Type of Shipping Bill:</strong> {salesData.typeofshippingbill || '-'}</p></Col>
//                     <Col md={6}><p><strong>Drawback A/C No:</strong> {salesData.drawbackacno || '-'}</p></Col>
//                     <Col md={4}><p><strong>Chapter Heading:</strong> {salesData.chapterheading || '-'}</p></Col>
//                     <Col md={4}><p><strong>Tariff Item:</strong> {salesData.tariffitem || '-'}</p></Col>
//                     <Col md={4}><p><strong>Drawback Rate:</strong> {salesData.drawbackrate || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Additional Information</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}>
//                         <p><strong>Description:</strong></p>
//                         <div className="border p-2 bg-light">
//                             {salesData.description || '-'}
//                         </div>
//                     </Col>
//                     <Col md={6}>
//                         <p><strong>LUT Details:</strong></p>
//                         <div className="border p-2 bg-light">
//                             {salesData.lut || '-'}
//                         </div>
//                     </Col>
//                     <Col md={6}><p><strong>From Date:</strong> {formatDate(salesData.fromdate)}</p></Col>
//                     <Col md={6}><p><strong>To Date:</strong> {formatDate(salesData.todate)}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Customer Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Customer:</strong> {salesData.customer?.companyname || '-'}</p></Col>
//                     <Col md={6}><p><strong>Contact Person:</strong> {salesData.contactperson || '-'}</p></Col>
//                     <Col md={6}><p><strong>Contact No:</strong> {salesData.contactno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Email:</strong> {salesData.email || '-'}</p></Col>
//                     <Col md={6}><p><strong>Customer Address:</strong> {salesData.customeraddress?.customeraddress || '-'}</p></Col>
//                     <Col md={6}><p><strong>Ship To:</strong> {salesData.shipto?.customeraddress || '-'}</p></Col>
//                     <Col md={6}><p><strong>Bill To:</strong> {salesData.billto?.customeraddress || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Terms</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Payment Terms:</strong> {salesData.customer?.paymentterm || '-'}</p></Col>
//                     <Col md={6}><p><strong>Incoterms:</strong> {salesData.customer?.incoterms || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Additional Information</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Destination:</strong> {salesData.destination || '-'}</p></Col>
//                     <Col md={6}><p><strong>Reference:</strong> {salesData.reference || '-'}</p></Col>
//                     <Col md={6}><p><strong>Packing List No:</strong> {salesData.packinglistno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Packing List Date:</strong> {formatDate(salesData.packinglistdate)}</p></Col>
//                     <Col md={6}><p><strong>Buyer Order No:</strong> {salesData.buyerorderno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Buyer Order Date:</strong> {formatDate(salesData.buyerorderdate)}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Sales Items</h5>
//                 <div className="table-responsive">
//                     <Table striped bordered hover>
//                         <thead>
//                             <tr>
//                                 <th>Product Description</th>
//                                 <th>Serial No</th>
//                                 <th>Model No</th>
//                                 <th>Tag No</th>
//                                 <th>Part No</th>
//                                 <th>MOC</th>
//                                 <th>Item Code</th>
//                                 <th>HSN Code</th>
//                                 <th>Quantity</th>
//                                 <th>UOM</th>
//                                 <th>Unit Price (Currency)</th>
//                                 <th>Total (Currency)</th>
//                                 <th>Unit Price (INR)</th>
//                                 <th>Total (INR)</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {rows.map((row, index) => (
//                                 <tr key={index}>
//                                     <td>
//                                         {row.description}
//                                         {row.productremarks && (
//                                             <div className="text-muted small mt-2">
//                                                 <strong>Remarks:</strong> {row.productremarks}
//                                             </div>
//                                         )}
//                                     </td>
//                                     <td>{row.serialnumber || '-'}</td>
//                                     <td>{row.modelnumber || '-'}</td>
//                                     <td>{row.tagnumber || '-'}</td>
//                                     <td>{row.partno || '-'}</td>
//                                     <td>{row.moc || '-'}</td>
//                                     <td>{row.itemcode || '-'}</td>
//                                     <td>{row.hsnsacno || '-'}</td>
//                                     <td>{row.quantity || '0'}</td>
//                                     <td>{row.uom || '-'}</td>
//                                     <td>{formatNumber(row.unitratecurrency)}</td>
//                                     <td>{formatNumber(row.totalcurrency)}</td>
//                                     <td>{formatNumber(row.unitRateInr)}</td>
//                                     <td>{formatNumber(row.totalInr)}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </div>

//                 {/* Totals Card */}
//                 <div className="card mt-3" style={{ width: '50%', marginLeft: 'auto' }}>
//                     <div className="card-header bg-light">
//                         <h5 className="mb-0">Sales Summary</h5>
//                     </div>
//                     <div className="card-body">
//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Net Total (INR)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(salesData.nettotalinr)}</strong>
//                             </div>
//                         </div>

//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Net Total (Currency)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(salesData.nettotalcurrency)}</strong>
//                             </div>
//                         </div>

//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Export Charges (Currency)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(salesData.exportpreperationchargescurrency)}</strong>
//                             </div>
//                         </div>

//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Export Charges (INR)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(
//                                     parseFloat(salesData.exportpreperationchargescurrency || 0) * 
//                                     parseFloat(salesData.salesexchangerate || 1)
//                                 )}</strong>
//                             </div>
//                         </div>

//                         <div className="row mt-3 pt-2 border-top">
//                             <div className="col-8 text-end">
//                                 <h5>Grand Total (INR)</h5>
//                             </div>
//                             <div className="col-4">
//                                 <h5>{formatNumberWithCommas(salesData.grandtotalinr)}</h5>
//                             </div>
//                         </div>

//                         <div className="row mt-2">
//                             <div className="col-8 text-end">
//                                 <h5>Grand Total (Currency)</h5>
//                             </div>
//                             <div className="col-4">
//                                 <h5>{formatNumberWithCommas(salesData.grandtotalcurrency)}</h5>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="d-flex justify-content-end mt-4">
//                     <button
//                         className="btn btn-secondary"
//                         type="button"
//                         onClick={() => navigate("/salesIndexTable/1")}
//                     >
//                         BACK TO LIST
//                     </button>
//                 </div>
//             </Form>
//         </div>
//     );
// };

// export default SalesAMView;





import React, { useEffect, useState } from "react";
import { Col, Table, Spinner, Badge, Row, Card, Button, Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";
import Swal from "sweetalert2";
import { FaArrowLeft, FaPrint, FaGlobe, FaShip, FaFileContract } from "react-icons/fa";

const SalesInternationalView = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [salesData, setSalesData] = useState(null);

    const fetchSalesData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
                headers: authHeader()
            });
            setSalesData(response.data);
        } catch (error) {
            console.error("Error fetching sales data", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch sales data. Please try again.",
            });
            navigate("/salesIndexTable/1");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSalesData();
    }, [id]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN');
    };

    const formatCurrency = (value, currency = 'INR') => {
        if (value === null || value === undefined || value === '') return '-';
        const num = parseFloat(value);
        return isNaN(num) ? '-' : new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    const formatNumber = (value) => {
        if (value === null || value === undefined || value === '') return '0.00';
        const num = parseFloat(value);
        return isNaN(num) ? '0.00' : num.toFixed(2);
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Draft': return 'secondary';
            case 'Submitted': return 'primary';
            case 'Approved': return 'success';
            case 'Rejected': return 'danger';
            case 'Completed': return 'info';
            case 'Open': return 'warning';
            default: return 'light';
        }
    };

    const getAddressString = (address) => {
        if (!address) return '-';
        return [
            address.customeraddress,
            address.city?.cityname,
            address.state?.statename,
            address.pincode,
            address.country?.countryname
        ].filter(Boolean).join(', ');
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (!salesData) {
        return (
            <Container className="mt-4">
                <div className="alert alert-danger text-center">Sales invoice not found</div>
            </Container>
        );
    }

    return (
        <Container fluid className="p-3">
            {/* Header Section */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="fw-bold text-primary mb-0">INTERNATIONAL SALES INVOICE - VIEW</h5>
                        <div className="d-flex gap-2">
                            <button 
                                className="btn btn-outline-white btn-sm"
                                onClick={() => navigate(`/salesInvoiceManufacturingInternational/print/${id}`)}
                            >
                                <FaPrint className="me-1" />
                                PRINT
                            </button>
                            <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
                                <FaArrowLeft className="me-1" />
                                Back
                            </button>
                        </div>
                    </div>
                    
                    <Row className="g-2">
                        <Col md={3}>
                            <div className="border-start border-3 border-primary ps-2">
                                <small className="text-muted">Invoice No</small>
                                <div className="fw-bold">{salesData.invoiceno}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-success ps-2">
                                <small className="text-muted">Invoice Date</small>
                                <div className="fw-bold">{formatDate(salesData.invoicedate)}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-warning ps-2">
                                <small className="text-muted">Currency</small>
                                <div className="fw-bold">{salesData.salescurrency || 'USD'}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-info ps-2">
                                <small className="text-muted">Status</small>
                                <div>
                                    <Badge 
                                        bg={getStatusBadge(salesData.status)} 
                                        className="px-2 py-1"
                                    >
                                        {salesData.status || '-'}
                                    </Badge>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Basic Information */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold"><FaFileContract className="me-2" />Invoice Information</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Tally Reference No</small>
                                <div className="fw-bold">{salesData.tallyreferenceno || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Dispatch Through</small>
                                <div className="fw-bold">{salesData.dispatchthrough || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Exchange Rate</small>
                                <div className="fw-bold">{formatNumber(salesData.salesexchangerate)}</div>
                            </div>
                            <div>
                                <small className="text-muted">Branch</small>
                                <div className="fw-bold">{salesData.branch?.branchname || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Warehouse</small>
                                <div className="fw-bold">{salesData.warehouse?.warehousename || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Reference</small>
                                <div className="fw-bold">{salesData.reference || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* International Sales Details */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold"><FaGlobe className="me-2" />International Details</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Kind Attention</small>
                                <div className="fw-bold">{salesData.kindattn || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Country of Destination</small>
                                <div className="fw-bold">{salesData.countryofdestination || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Country of Origin</small>
                                <div className="fw-bold">{salesData.countryoforigin || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Air/Sea</small>
                                <div className="fw-bold">{salesData.airsea || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Port of Loading</small>
                                <div className="fw-bold">{salesData.portofloading || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Port of Discharge</small>
                                <div className="fw-bold">{salesData.portofdischarge || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Shipping Details */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold"><FaShip className="me-2" />Shipping Details</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">No. of Boxes</small>
                                <div className="fw-bold">{salesData.noofboxes || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Net Weight (kg)</small>
                                <div className="fw-bold">{salesData.netweightofboxes || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Gross Weight (kg)</small>
                                <div className="fw-bold">{salesData.grossweightofboxes || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Customs & Regulatory Details */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Customs & Regulatory Details</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">LUT Bond No</small>
                                <div className="fw-bold">{salesData.lutbondno || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">LUT Bond Date</small>
                                <div className="fw-bold">{formatDate(salesData.lutbonddate)}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Type of Shipping Bill</small>
                                <div className="fw-bold">{salesData.typeofshippingbill || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Drawback A/C No</small>
                                <div className="fw-bold">{salesData.drawbackacno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Chapter Heading</small>
                                <div className="fw-bold">{salesData.chapterheading || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Tariff Item</small>
                                <div className="fw-bold">{salesData.tariffitem || '-'}</div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mt-2">
                                <small className="text-muted">Drawback Rate</small>
                                <div className="fw-bold">{salesData.drawbackrate || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Customer Information */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Customer Information</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Company Name</small>
                                <div className="fw-bold">{salesData.customer?.companyname || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Contact Person</small>
                                <div className="fw-bold">{salesData.contactperson || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Contact No</small>
                                <div className="fw-bold">{salesData.contactno || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Email</small>
                                <div className="fw-bold">{salesData.email || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Payment Terms</small>
                                <div className="fw-bold">{salesData.customer?.paymentterm || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Incoterms</small>
                                <div className="fw-bold">{salesData.customer?.incoterms || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Bill To and Ship To */}
            <Row className="mb-3">
                <Col md={6}>
                    <Card className="shadow-sm border-0 rounded h-100">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 fw-bold">Bill To</h6>
                        </Card.Header>
                        <Card.Body className="p-3">
                            {salesData.billto ? (
                                <>
                                    <div className="mb-2">
                                        <small className="text-muted">Address</small>
                                        <div className="fw-bold">{getAddressString(salesData.billto)}</div>
                                    </div>
                                    <div>
                                        <small className="text-muted">GST</small>
                                        <div className="fw-bold">{salesData.billto.gstno || '-'}</div>
                                    </div>
                                </>
                            ) : (
                                <div className="text-muted">No billing address specified</div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="shadow-sm border-0 rounded h-100">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 fw-bold">Ship To</h6>
                        </Card.Header>
                        <Card.Body className="p-3">
                            {salesData.shipto ? (
                                <>
                                    <div className="mb-2">
                                        <small className="text-muted">Address</small>
                                        <div className="fw-bold">{getAddressString(salesData.shipto)}</div>
                                    </div>
                                    <div className="mb-2">
                                        <small className="text-muted">Contact</small>
                                        <div className="fw-bold">{salesData.shipto.contactperson || '-'}</div>
                                    </div>
                                    <div>
                                        <small className="text-muted">Phone</small>
                                        <div className="fw-bold">{salesData.shipto.contactno || '-'}</div>
                                    </div>
                                </>
                            ) : (
                                <div className="text-muted">No shipping address specified</div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Additional Information */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Additional Information</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={6}>
                            <div className="mb-2">
                                <small className="text-muted">Description</small>
                                <div className="fw-bold border p-2 bg-light rounded">
                                    {salesData.description || '-'}
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-2">
                                <small className="text-muted">LUT Details</small>
                                <div className="fw-bold border p-2 bg-light rounded">
                                    {salesData.lut || '-'}
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">From Date</small>
                                <div className="fw-bold">{formatDate(salesData.fromdate)}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">To Date</small>
                                <div className="fw-bold">{formatDate(salesData.todate)}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Destination</small>
                                <div className="fw-bold">{salesData.destination || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Products Table */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Products</h6>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table bordered size="sm" className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center fw-bold py-2">#</th>
                                    <th className="fw-bold py-2">Description</th>
                                    <th className="fw-bold py-2">Serial No</th>
                                    <th className="fw-bold py-2">Model No</th>
                                    <th className="fw-bold py-2">Tag No</th>
                                    <th className="fw-bold py-2">Part No</th>
                                    <th className="fw-bold py-2">MOC</th>
                                    <th className="fw-bold py-2">Item Code</th>
                                    <th className="fw-bold py-2">HSN Code</th>
                                    <th className="fw-bold py-2 text-center">Qty</th>
                                    <th className="fw-bold py-2 text-center">UOM</th>
                                    <th className="fw-bold py-2 text-end">Unit Price (FC)</th>
                                    <th className="fw-bold py-2 text-end">Total (FC)</th>
                                    <th className="fw-bold py-2 text-end">Unit Price (INR)</th>
                                    <th className="fw-bold py-2 text-end">Total (INR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {salesData.salesItems?.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td>
                                            <div className="fw-semibold">{item.product?.description || '-'}</div>
                                            {item.productremarks && (
                                                <div className="text-muted small mt-1">
                                                    <small><strong>Remarks:</strong> {item.productremarks}</small>
                                                </div>
                                            )}
                                        </td>
                                        <td>{item.serialnumber || '-'}</td>
                                        <td>{item.modelnumber || '-'}</td>
                                        <td>{item.tagnumber || '-'}</td>
                                        <td>{item.partno || '-'}</td>
                                        <td>{item.product?.moc || '-'}</td>
                                        <td>{item.itemcode || '-'}</td>
                                        <td>{item.hsnsacno || '-'}</td>
                                        <td className="text-center">{item.quantity}</td>
                                        <td className="text-center">{item.uom || '-'}</td>
                                        <td className="text-end">{formatCurrency(item.unitratecurrency)}</td>
                                        <td className="text-end">{formatCurrency(item.totalcurrency)}</td>
                                        <td className="text-end">{formatCurrency(item.unitrateinr)}</td>
                                        <td className="text-end fw-bold">{formatCurrency(item.totalinr)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>

            {/* Summary Section */}
            <Row>
                <Col lg={6} className="ms-auto">
                    <Card className="shadow-sm border-0 rounded">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 fw-bold text-center">Sales Summary</h6>
                        </Card.Header>
                        <Card.Body className="p-3">
                            <div className="space-y-2">
                                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                    <span className="fw-semibold">Net Total (INR):</span>
                                    <span className="fw-bold">{formatCurrency(salesData.nettotalinr)}</span>
                                </div>
                                
                                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                    <span className="fw-semibold">Net Total ({salesData.salescurrency || 'USD'}):</span>
                                    <span className="fw-bold">{formatCurrency(salesData.nettotalcurrency)}</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                    <span className="fw-semibold">Export Charges ({salesData.salescurrency || 'USD'}):</span>
                                    <span className="fw-bold">{formatCurrency(salesData.exportpreperationchargescurrency)}</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                    <span className="fw-semibold">Export Charges (INR):</span>
                                    <span className="fw-bold">
                                        {formatCurrency(
                                            parseFloat(salesData.exportpreperationchargescurrency || 0) * 
                                            parseFloat(salesData.salesexchangerate || 1)
                                        )}
                                    </span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center py-2 border-top">
                                    <span className="fw-bold text-primary">Grand Total (INR)</span>
                                    <span className="fw-bold text-primary fs-5">{formatCurrency(salesData.grandtotalinr)}</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center py-2 border-top">
                                    <span className="fw-bold text-success">Grand Total ({salesData.salescurrency || 'USD'})</span>
                                    <span className="fw-bold text-success fs-5">{formatCurrency(salesData.grandtotalcurrency)}</span>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Footer Actions */}
            <div className="text-center mt-3 pt-2 border-top">
                <button 
                    className="btn btn-secondary btn-sm"
                    onClick={() => navigate(-1)}
                >
                    <FaArrowLeft className="me-1" />
                    Back to List
                </button>
            </div>
        </Container>
    );
};

export default SalesInternationalView;